const translation = {
  common: {
    appName: "KitAuto",
    home: "Home",
    search: "Search",
    wishlist: "Wishlist",
    cart: "Cart",
    notifications: "Notifications",
    noNotifications: "No notifications",
    profile: "Profile",
    manageProfile: "Manage Profile",
    logout: "Logout",
    signOut: "Sign Out",
    welcome: "Welcome",
    signInPrompt: "Sign in to your account",
    or: "OR",
    changeLanguage: "Change Language",
    languages: {
      en: "English",
      fr: "French"
    },
    createAccount: "Create Account",
    signUpPrompt: "Create your account to get started",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    anonymous: "Anonymous",
    logoutSuccess: "You have been successfully logged out"
  },
  product: {
    addNew: "Add New Product",
    addToCart: "Add to Cart",
    addToWishlist: "Add to Wishlist",
    categories: {
      body: "Body Parts",
      electrical: "Electrical Parts",
      engine: "Engine Parts",
      transmission: "Transmission",
      brakes: "Brakes",
      suspension: "Suspension",
      interior: "Interior",
      accessories: "Accessories"
    },
    conditions: {
      new: "New",
      used: "Used",
      refurbished: "Refurbished"
    },
    basicInfo: "Basic Information",
    detailsSpecs: "Details & Specifications",
    imagesPreview: "Images & Preview",
    addNewProduct: "Add New Product",
    title: "Title",
    description: "Description",
    price: "Price",
    category: "Category",
    condition: "Condition",
    back: "Back",
    next: "Next",
    addImages: "Add Images",
    uploadLimit: "Maximum 5 images allowed",
    stock: "Stock",
    brand: "Brand",
    model: "Model",
    location: "Location",
    brandPlaceholder: "Enter brand name",
    modelPlaceholder: "Enter model name",
    locationPlaceholder: "Enter location",
    year: {
      label: "Year",
      placeholder: "Enter year",
      errors: {
        required: "Year is required",
        invalid: "Invalid year",
        future: "Year cannot be in the future",
        tooOld: "Year cannot be before 1900"
      }
    },
    form: {
      errors: {
        validation: "Please fix the highlighted errors before submitting",
        title: "Form contains errors",
        description: "Review the form and correct the highlighted fields"
      }
    },
    pleaseAddImage: "Please add at least one image",
    saving: "Saving...",
    visibility: {
      visible: "Visible",
      hidden: "Hidden"
    },
    visibilityUpdated: "Product visibility updated successfully",
    image: "Image",
    share: "Share",
    sellerInfo: "Seller Information",
    stockCount: "{{count}} in stock",
    additionalInfo: "Additional Information",
    shipping: {
      title: "Shipping",
      description: "Free shipping on orders over $100. Standard delivery 3-5 business days."
    },
    payment: {
      title: "Payment",
      description: "Secure payment through our trusted payment providers."
    },
    warranty: {
      title: "Warranty",
      description: "30-day return policy for unused items in original packaging."
    },
    message: {
      contactSeller: "Contact Seller",
      writeMessage: "Write a Message",
      placeholder: "Type your message here...",
      send: "Send Message"
    },
    specifications: {
      attribute: "Attribute",
      value: "Value"
    },
    memberSince: "Member since",
    contactSeller: "Contact Seller",
    removeFromWishlist: "Remove from Wishlist",
    wishlist: {
      addedToWishlist: "Added to wishlist",
      removedFromWishlist: "Removed from wishlist"
    },
    details: {
      messageSuccess: "Message sent successfully",
      messageError: "Failed to send message",
      outOfStock: "Out of stock",
      inStock: "In stock",
      quantity: "Quantity",
      sendingMessage: "Sending...",
      messagePlaceholder: "Write your message here...",
      messageMaxLength: "Message cannot exceed 500 characters",
      messageRequired: "Please enter a message"
    },
    cart: {
      addedToCart: "Added to cart",
      failedToAdd: "Failed to add to cart"
    },
    unavailable: "Product no longer available",
    addedSuccessProduct: "Product added successfully\n, it will be visible after approval",
    reviews: {
      title: "Reviews",
      addReview: "Add Review",
      noReviews: "No reviews yet"
    }
  },
  auth: {
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    sendResetLink: "Send Reset Link",
    backToLogin: "Back to Login",
    loginWithGoogle: "Login with Google",
    registerWithGoogle: "Register with Google",
    name: "Full Name",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    loginError: "Login failed. Please check your credentials.",
    registerError: "Registration failed. Please try again.",
    resetSuccess: "Password reset link sent to your email",
    resetError: "Failed to send reset link",
    passwordMismatch: "Passwords do not match",
    signIn: "Sign In",
    signUp: "Sign Up",
    signInWith: {
      google: "Sign in with Google",
      facebook: "Sign in with Facebook"
    },
    signUpWith: {
      google: "Sign up with Google",
      facebook: "Sign up with Facebook"
    },
    dontHaveAccount: "Don't have an account?",
    signup: {
      title: "Create Account",
      subtitle: "Join our community",
      name: {
        label: "Full Name",
        placeholder: "Enter your full name",
        required: "Name is required"
      },
      email: {
        label: "Email Address",
        placeholder: "Enter your email",
        required: "Email is required",
        invalid: "Please enter a valid email"
      },
      password: {
        label: "Password",
        placeholder: "Create a password",
        required: "Password is required",
        minLength: "Password must be at least 6 characters",
        requirements: "Password must contain letters, numbers, and special characters"
      },
      confirmPassword: {
        label: "Confirm Password",
        placeholder: "Confirm your password",
        required: "Please confirm your password",
        mismatch: "Passwords do not match"
      },
      submit: "Create Account",
      alreadyHaveAccount: "Already have an account?",
      signIn: "Sign in here",
      or: "or continue with",
      terms: {
        agree: "By signing up, you agree to our",
        termsLink: "Terms of Service",
        and: "and",
        privacyLink: "Privacy Policy"
      },
      success: "Account created successfully",
      error: {
        default: "Failed to create account",
        emailInUse: "Email is already in use",
        weak: "Password is too weak",
        invalid: "Invalid email format"
      },
      form: {
        title: "Sign Up",
        name: "Name",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        button: "Sign Up",
        googleButton: "Sign up with Google",
        facebookButton: "Sign up with Facebook",
        haveAccount: "Already have an account?",
        loginLink: "Login here",
        errors: {
          nameRequired: "Name is required",
          emailRequired: "Email is required",
          emailInvalid: "Invalid email format",
          passwordRequired: "Password is required",
          passwordMinLength: "Password must be at least 6 characters",
          confirmPasswordRequired: "Please confirm your password",
          passwordsNotMatch: "Passwords do not match"
        }
      }
    },
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    alreadyHaveAccount: "Already have an account?",
    errors: {
      invalidEmail: "Invalid email address",
      invalidPassword: "Invalid password",
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      wrongCredentials: "Incorrect email or password",
      accountNotFound: "No account found with this email",
      nameRequired: "Name is required",
      phoneRequired: "Phone number is required",
      emailInUse: "This email is already in use",
      passwordTooShort: "Password must be at least 6 characters",
      passwordsDoNotMatch: "Passwords do not match",
      invalidPhoneNumber: "Invalid phone number format",
      socialLoginFailed: "Failed to login with {{provider}}",
      defaultError: "Something went wrong. Please try again.",
      networkError: "Network error. Please check your connection.",
      tooManyAttempts: "Too many attempts. Please try again later."
    },
    validation: {
      required: "This field is required",
      email: {
        required: "Email is required",
        invalid: "Invalid email address"
      },
      password: {
        required: "Password is required",
        minLength: "Password must be at least 6 characters"
      },
      name: {
        required: "Name is required"
      },
      phone: {
        required: "Phone number is required",
        invalid: "Invalid phone number format"
      },
      positiveNumber: "Must be a positive number",
      integer: "Must be a whole number",
      stockMin: "Stock must be at least 0"
    }
  },
  search: {
    mainTitle: "Find Car Parts",
    subTitle: "Search through thousands of auto parts",
    searchParts: "Search parts...",
    category: "Category",
    allCategories: "All Categories",
    categories: {
      engine: "Engine",
      transmission: "Transmission",
      brakes: "Brakes",
      suspension: "Suspension",
      electrical: "Electrical",
      body: "Body"
    },
    filters: "Filters",
    sortBy: "Sort By",
    sortOptions: {
      newest: "Newest First",
      priceLow: "Price: Low to High",
      priceHigh: "Price: High to Low",
      popular: "Most Popular"
    },
    viewProduct: "View Product",
    shareProduct: "Share Product",
    moreActions: "More Actions",
    noResults: "No products found",
    tryDifferentFilters: "Try different filters or search terms",
    noMoreProducts: "No more products to load"
  },
  validation: {
    required: "This field is required",
    positiveNumber: "Must be a positive number",
    integer: "Must be a whole number",
    stockMin: "Stock must be at least 0",
    fields: {
      title: "Title is required",
      description: "Description is required",
      price: "Price is required",
      brand: "Brand is required",
      model: "Model is required",
      category: "Category is required",
      condition: "Condition is required",
      location: "Location is required",
      stock: "Stock is required",
      images: "At least one image is required"
    }
  },
  profile: {
    myProducts: "My Products",
    messages: {
      title: "Messages",
      regarding: "Regarding",
      selectConversation: "Select a conversation",
      empty: "No messages yet",
      conversationWith: "Conversation with {{name}}",
      quickReplies: {
        yes: "Yes, available",
        no: "Not available",
        price: "Price is firm",
        negotiate: "Can negotiate",
        thanks: "Thank you"
      },
      typing: "Type a message...",
      justNow: "Just now",
      minutesAgo: "{{minutes}}m ago",
      hoursAgo: "{{hours}}h ago",
      yesterday: "Yesterday",
      daysAgo: "{{days}} days ago",
      messagesSent: "Message sent successfully",
      messageError: "Failed to send message"
    },
    orders: {
      orders: "Orders",
      placed: "Placed Orders",
      received: "Received Orders"
    },
    noReceivedOrders: "No orders received yet",
    settings: "Settings",
    info: {
      email: "Email",
      phone: "Phone",
      address: "Address",
      company: "Company",
      companyNotAdded: "No company added",
      phoneNotAdded: "No phone number added",
      addressNotAdded: "No address added"
    },
    buttons: {
      editProfile: "Edit Profile",
      saveChanges: "Save Changes"
    },
    accountSettings: "Account Settings",
    security: "Security",
    changePassword: "Change Password",
    changePasswordDesc: "Update your password to keep your account secure",
    change: "Change",
    notifications: "Notifications",
    enableNotifications: "Enable Notifications",
    enableNotificationsDesc: "Receive notifications about your account activity",
    messageNotifications: "Message Notifications",
    messageNotificationsDesc: "Get notified when you receive new messages",
    orderNotifications: "Order Notifications",
    orderNotificationsDesc: "Get notified about your order status updates",
    settingsUpdated: "Notification settings updated successfully",
    settingsUpdateError: "Failed to update notification settings",
    privacy: "Privacy",
    profileVisibility: "Profile Visibility",
    profileVisibilityDesc: "Make your profile visible to other users",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    product: {
      menu: {
        view: "View Product",
        edit: "Edit Product",
        delete: "Delete Product",
        toggleVisibility: {
          show: "Show Product",
          hide: "Hide Product"
        }
      },
      inStock: "in stock"
    },
    deleteProduct: "Delete Product",
    deleteConfirmation: "Are you sure you want to delete this item?",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    deleteAccountWarning: "This action cannot be undone. All your data will be permanently deleted.",
    confirmDelete: "Confirm Delete",
    noOrders: "No orders yet",
    startShopping: "Start Shopping",
    labels: {
      name: "Name",
      bio: "Bio",
      phone: "Phone Number",
      address: "Address",
      company: "Company Name"
    },
    noProducts: "You haven't added any products yet",
    addProduct: "Add Product",
    order: {
      orderId: "Order #{{id}}",
      status: {
        pending: "Pending",
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        completed: "Completed",
        cancelled: "Cancelled"
      },
      quantity: "Quantity",
      total: "Total",
      buyer: "Buyer",
      contact: "Contact",
      address: "Shipping Address"
    },
    stats: {
      products: "Products",
      messages: "Conversations",
      orders: "Orders",
      favorites: "Favorites"
    },
    productDeleted: "Product deleted successfully",
    deleteError: "Failed to delete product",
    deleteProduct: "Delete Product",
    deleteConfirmation: "Are you sure you want to delete this product?"
  },
  editProduct: {
    title: "Edit Product",
    labels: {
      title: "Title",
      description: "Description",
      price: "Price",
      category: "Category",
      brand: "Brand",
      model: "Model",
      year: "Year",
      condition: "Condition",
      stock: "Stock",
      location: "Location"
    },
    images: {
      title: "Product Images",
      currentImages: "Current Images",
      delete: "Delete Image",
      addMore: "Add More Images",
      uploadLimit: "Maximum 5 images allowed"
    },
    buttons: {
      save: "Save Changes",
      updateSuccess: "Product updated successfully"
    }
  },
  wishlist: {
    title: "My Wishlist",
    empty: "Your wishlist is empty",
    startShopping: "Start Shopping",
    removeFromWishlist: "Remove from wishlist",
    removeSuccess: "Product removed from wishlist",
    removeError: "Failed to remove product from wishlist",
    addToCart: "Add to Cart",
    addToCartSuccess: "Product added to cart",
    addToCartError: "Failed to add product to cart"
  },
  cart: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    startShopping: "Start Shopping",
    summary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    checkout: "Proceed to Checkout",
    remove: "Remove",
    quantity: "Quantity",
    updateQuantity: "Update quantity",
    free: "Free",
    itemRemoved: "Item removed from cart",
    removeError: "Failed to remove item",
    quantityUpdated: "Quantity updated",
    updateError: "Failed to update quantity",
    items: "{{count}} items",
    item: "{{count}} item",
    estimatedTotal: "Estimated Total"
  },
  checkout: {
    title: "Checkout",
    shippingAddress: "Shipping Address",
    paymentMethod: "Payment Method",
    orderSummary: "Order Summary",
    billingAddress: "Billing Address",
    sameAsShipping: "Same as shipping address",
    placeOrder: "Place Order",
    backToCart: "Back to Cart",
    fields: {
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      state: "State",
      zipCode: "ZIP Code",
      country: "Country",
      cardNumber: "Card Number",
      expiryDate: "Expiry Date",
      cvv: "CVV"
    },
    summary: {
      subtotal: "Subtotal",
      shipping: "Shipping",
      total: "Total",
      items: "{{count}} items",
      item: "{{count}} item"
    },
    validation: {
      required: "This field is required",
      invalidEmail: "Invalid email address",
      invalidPhone: "Invalid phone number",
      invalidCard: "Invalid card number",
      invalidExpiry: "Invalid expiry date",
      invalidCVV: "Invalid CVV",
      fillRequired: "Please fill in all required fields"
    },
    success: {
      title: "Order Placed Successfully!",
      message: "Thank you for your order. We'll send you a confirmation email shortly.",
      continue: "Continue Shopping"
    },
    error: {
      title: "Error",
      message: "There was a problem processing your order. Please try again.",
      retry: "Try Again"
    },
    form: {
      shippingDetails: "Shipping Details",
      paymentDetails: "Payment Details",
      cardInfo: "Card Information",
      saveForNextTime: "Save for next time",
      differentBilling: "Use different billing address",
      billingInfo: "Billing Information",
      paymentInfo: "Payment Information",
      orderDetails: "Order Details",
      saveCard: "Save card for future purchases",
      termsAccept: "I accept the terms and conditions",
      shippingMethod: "Shipping Method",
      standardShipping: "Standard Shipping (3-5 business days)",
      expressShipping: "Express Shipping (1-2 business days)",
      freeShippingNote: "Free shipping on orders over $100",
      cashOnDelivery: "Cash on Delivery",
      cashDescription: "Pay when you receive your order",
      creditCard: "Credit/Debit Card",
      cardDescription: "Secure online payment",
      bankTransfer: "Bank Transfer",
      bankDescription: "Direct bank transfer",
      selectPayment: "Select Payment Method"
    },
    placeholders: {
      cardNumber: "1234 5678 9012 3456",
      expiryDate: "MM/YY",
      cvv: "123"
    },
    messages: {
      processing: "Processing your order...",
      cardDeclined: "Your card was declined",
      invalidShipping: "Please fill in all shipping details",
      invalidPayment: "Please fill in all payment details",
      orderProcessing: "Processing your order...",
      orderSuccess: "Order placed successfully!",
      orderError: "Error placing order",
      shippingError: "Please fill all shipping details",
      paymentError: "Please fill all payment details",
      cardError: "Invalid card details"
    },
    buttons: {
      next: "Next",
      back: "Back",
      placeOrder: "Place Order",
      continue: "Continue Shopping"
    },
    emptyCart: "Your cart is empty. Please add some items before proceeding to checkout.",
    free: "Free",
    quantity: "Quantity"
  },
  orderSuccess: {
    title: "Order Placed Successfully!",
    subtitle: "Thank you for your order. We'll send you a confirmation email with your order details.",
    orderId: "Order #{{id}}",
    paymentMessages: {
      cash: "Please have the payment ready when your order arrives.",
      processed: "Your payment has been processed successfully."
    },
    buttons: {
      continueShopping: "Continue Shopping",
      viewOrders: "View Orders"
    }
  },
  breadcrumbs: {
    home: "Home",
    parts: "Parts",
    categories: {
      body: "Body Parts",
      electrical: "Electrical Parts",
      engine: "Engine Parts",
      transmission: "Transmission",
      brakes: "Brakes",
      suspension: "Suspension",
      interior: "Interior",
      accessories: "Accessories"
    }
  },
  notifications: {
    messages: {
      new: "New message from {{sender}}",
      preview: "{{message}}"
    },
    orders: {
      new: "New order from {{buyer}}",
      preview: "{{quantity}}x {{product}}"
    },
    timeAgo: {
      justNow: "Just now",
      minutes: "{{count}}m ago",
      hours: "{{count}}h ago",
      days: "{{count}}d ago"
    },
    empty: "No notifications"
  },
  settings: {
    notifications: {
      title: "Notification Settings",
      enable: "Enable Notifications",
      messages: "Message Notifications",
      orders: "Order Notifications",
      marketing: "Marketing Notifications",
      updateSuccess: "Notification settings updated",
      updateError: "Failed to update notification settings"
    }
  },
  rating: {
    outOf: "out of",
    reviews: "reviews",
    writeReview: "Write a Review",
    updateReview: "Update your review",
    commentPlaceholder: "Share your experience with this product...",
    submit: "Submit Review",
    update: "Update",
    submitSuccess: "Review submitted successfully",
    submitError: "Failed to submit review",
    loadError: "Failed to load reviews",
    loginRequired: "Please sign in to write a review",
    cannotRateOwnProduct: "You cannot rate your own product",
    noReviews: "No reviews yet"
  }
};

export default translation;